import { normalizeApiBaseUrl } from './apiBaseUrl';

/** env 가 모두 비어 있을 때 플랫폼 REST 기본 호스트 (목업 대신 실호출) */
export const DEFAULT_STUDY_RESULT_PLATFORM_BASE_URL = 'https://api2_test.medicrew.me';

/**
 * `docs/api/studyResultOld.json` 실습기록·랩·시나리오 플랫폼 API 베이스 (api2 스테이지).
 * - 우선: `REACT_APP_STUDY_RESULT_API_BASE_URL`
 * - 다음: `REACT_APP_PLATFORM_API_BASE_URL`
 * - 둘 다 비어 있으면 `DEFAULT_STUDY_RESULT_PLATFORM_BASE_URL` (api2 테스트)
 */
export function getStudyResultPlatformBaseUrl(): string {
	const primary = normalizeApiBaseUrl(process.env.REACT_APP_STUDY_RESULT_API_BASE_URL);
	if (primary) return primary;
	const secondary = normalizeApiBaseUrl(process.env.REACT_APP_PLATFORM_API_BASE_URL);
	if (secondary) return secondary;
	return normalizeApiBaseUrl(DEFAULT_STUDY_RESULT_PLATFORM_BASE_URL);
}
